






























































import BaseDialog from '@/components/BaseDialog.vue';

import { PropType } from 'vue';
import { TAiStreamerScriptRecord, ValidationRules } from '@/api/schema';
import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  createAiStreamerScript,
  updateAiStreamerScript
} from '@/api/CopyStake/AiStreamer';

const MAX_SCRIPT_LENGTH = 1000 * 80;

const defaultFormData = (): Partial<TAiStreamerScriptRecord> => {
  return {
    id: null,
    name: '',
    phrasesText: ''
  };
};

export default {
  name: 'CopyStakeAutoclickerPromptsModal',
  components: {
    BaseDialog
  },
  props: {
    promptData: {
      type: Object as PropType<Partial<TAiStreamerScriptRecord>>,
      default: null
    },
    language: {
      type: String
    },
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      formData: { ...defaultFormData() },
      isFormValid: true,
      loading: {
        processing: false
      },
      MAX_SCRIPT_LENGTH
    };
  },
  computed: {
    isNewConfig(): boolean {
      return !this.promptData;
    },
    isCopyConfig(): boolean {
      return !this.promptData?.id && this.promptData?.name;
    },
    isEditConfig(): boolean {
      return this.promptData?.id && this.promptData?.name;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    formattedMaxLimit(): string {
      return this.$options.filters.numeralSpaces(
        this.MAX_SCRIPT_LENGTH,
        '0,0[00]'
      );
    },

    getTitle(): string {
      if (this.isCopyConfig) return 'Add Script from Copy';
      if (this.isEditConfig) return 'Edit Script';

      return 'Add New Script';
    },
    getSubmitText(): string {
      if (this.isCopyConfig) return 'Save as New';
      if (this.isEditConfig) return 'Save Changes';

      return 'Add Script';
    },

    rules(): ValidationRules {
      return {
        name: [(v: string) => vr.required(v, 'Script Name')],
        phrasesText: [
          (v: string) => vr.required(v, 'Script Text'),
          (v: string) => {
            return (
              (v && v.length <= this.MAX_SCRIPT_LENGTH) ||
              `Base script text is too long. Maximum allowed length is ${this.formattedMaxLimit} characters.`
            );
          }
        ]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetForm();

      if (!open) {
        return;
      }

      if (this.isEditConfig || this.isCopyConfig)
        this.formData = {
          ...this.promptData
        };
    }
  },
  methods: {
    async resetForm(): Promise<void> {
      await this.$refs.form?.reset();

      this.formData = { ...defaultFormData() };
    },

    async handleSubmit(): Promise<void> {
      await this.$refs.form.validate();

      if (!this.isFormValid || this.isLoading || !this.language) return;

      this.loading.processing = true;

      const cleanedPhrases = (this.formData.phrasesText || '')
        .toString()
        .trim();

      const payload = {
        name: this.formData.name,
        language: this.language,
        phrasesText: cleanedPhrases
      };

      if (this.isNewConfig || this.isCopyConfig) {
        createAiStreamerScript(payload)
          .then((data) => {
            this.$toast.success('AI Streamer Script created');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      } else {
        updateAiStreamerScript(this.promptData.id, payload)
          .then((data) => {
            this.$toast.success('AI Streamer Script updated');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
